/**
 * M3 controls (plan §2.6.6, §2.10; D-TBD 16): `src/data/reach-controls.json`, Zod-validated here. M3 keeps its own
 * bindings file and never edits M1's `bindings.json` or `src/input/**`.
 */
import { z } from 'zod'
import controlsJson from '../data/reach-controls.json'

const codes = z.array(z.string().min(1)).min(1)
const button = z.number().int().min(0).max(31)
const holdS = z.number().positive().max(5)

export const reachControlsSchema = z.object({
  comment: z.string().optional(),
  keyboard: z.object({
    map: codes,
    cruise: codes,
    scan: codes,
    interact: codes,
    throttleUp: codes,
    throttleDown: codes,
    plotRoute: codes,
    mapZoomOut: codes,
    mapZoomIn: codes,
  }),
  gamepad: z.object({
    /** View held `holdS` (a View tap is reserved for M2's tool mode). */
    map: z.object({ button, holdS }),
    /** A chord: every button held (L3 + R3). */
    cruise: z.object({ buttons: z.array(button).min(1) }),
    scan: z.object({ button }),
    /** D-pad down held `holdS` (a tap still toggles the camera). */
    interact: z.object({ button, holdS }),
    mapSelect: button,
    mapBack: button,
    mapZoomOut: button,
    mapZoomIn: button,
    throttleAxis: z.number().int().min(0).max(15),
    throttleDeadzone: z.number().min(0).max(0.9),
  }),
  /** When true, the deep scan also needs no target selected (spec §6.2); false until the M2 bridge (D-TBD 16). */
  deepScanRequiresNoTarget: z.boolean(),
})

export type ReachControls = z.infer<typeof reachControlsSchema>

/** Parses and validates reach-controls.json (throws a ZodError naming the bad field). */
export function loadReachControls(raw: unknown = controlsJson): ReachControls {
  return reachControlsSchema.parse(raw)
}
